document.addEventListener('click', function (e) {
  var btn = e.target.closest('.complementary-products--nav');
  if (!btn) return;
  var wrapper = btn.closest('.complementary-products--wrapper');
  var inner = wrapper && wrapper.querySelector('.complementary-products--inner');
  if (!inner) return;
  var card = inner.querySelector('.product-card-small');
  var cardWidth = card ? card.getBoundingClientRect().width + 10 : 350;
  var amount = btn.classList.contains('complementary-products--prev') ? -cardWidth : cardWidth;
  inner.scrollBy({ left: amount, behavior: 'smooth' });
});